var _a;
import * as React from 'react';
import { Box, ButtonBase, Radio, Typography } from '@mui/material';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import { APPLICATION_TYPES } from '../../../config/constants';
import { applicationTypeIconSx, applicationTypeTileSx, TILE_BODY_SX, TILE_DESCRIPTION_SX, TILE_RADIO_SX, TILE_TITLE_SX, } from './start_application_styles';
var APPLICATION_TYPE_ICONS = (_a = {},
    _a[APPLICATION_TYPES.NOR] = React.createElement(FactCheckOutlinedIcon, null),
    _a[APPLICATION_TYPES.LOC] = React.createElement(DescriptionOutlinedIcon, null),
    _a[APPLICATION_TYPES.DORF] = React.createElement(CheckCircleOutlineIcon, null),
    _a[APPLICATION_TYPES.SCH] = React.createElement(CalendarMonthOutlinedIcon, null),
    _a);
var ApplicationTypeTile = function (_a) {
    var value = _a.value, label = _a.label, description = _a.description, isSelected = _a.isSelected, onSelect = _a.onSelect;
    var handleClick = React.useCallback(function () { return onSelect(value); }, [onSelect, value]);
    return (React.createElement(ButtonBase, { role: "radio", "aria-checked": isSelected, onClick: handleClick, sx: applicationTypeTileSx(isSelected) },
        React.createElement(Box, { "aria-hidden": true, sx: applicationTypeIconSx(isSelected) }, APPLICATION_TYPE_ICONS[value]),
        React.createElement(Box, { sx: TILE_BODY_SX },
            React.createElement(Typography, { sx: TILE_TITLE_SX }, label),
            React.createElement(Typography, { sx: TILE_DESCRIPTION_SX }, description)),
        React.createElement(Radio, { checked: isSelected, tabIndex: -1, size: "small", sx: TILE_RADIO_SX })));
};
export default React.memo(ApplicationTypeTile);
